/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect } from 'react'
import ApexCharts from 'apexcharts'
import { IDadoGrafico2 } from '../..'
import { Flex } from '@chakra-ui/react'
import { HSelect } from '../../../../../Utils/Helper'

interface iChartProps {
  model: IDadoGrafico2[]
  setGrafico: (blob: string) => void
}

export const BarChartIndicativaPDF: React.FC<iChartProps> = ({ model, setGrafico }) => {
  const id = 'dalinho-PDF'
  const valorOrdenado = [...model].sort((a, b) => parseFloat(b.media) - parseFloat(a.media))

  function ObterCor(value: IDadoGrafico2[]): string[] {
    const arr: string[] = []
    value?.forEach(e => {
      if (e.melhoria) {
        arr.push('#F2994A')
      } else {
        arr.push('#27AE60')
      }
    })

    return arr
  }

  async function GerarGrafico(): Promise<void> {
    const element = document.querySelector(`#${id}`)
    if (!element) return

    let animationEnded = false

    const options = {
      series: [{
        data: HSelect(valorOrdenado, e => e.media, false)
      }],
      grid: { show: false },
      chart: {
        type: 'bar',
        height: (valorOrdenado.length * 80) < 721 ? (valorOrdenado.length * 80) : 720,
        width: 1000,
        toolbar: { show: false },
        animations: { enabled: false },

        // ✅ Adiciona listener de evento interno do ApexCharts
        events: {
          animationEnd: () => { animationEnded = true }
        }
      },
      stroke: { show: false, colors: ['#ffffff'] },
      annotations: {
        xaxis: [
          {
            x: 0,
            borderColor: '#c2c2c2',
            fillColor: '#c2c2c2',
            opacity: 0.8
          }
        ]
      },
      dataLabels: {
        enabled: true,
        position: 'start',
        offsetX: 55,
        offsetY: -14,
        formatter: function (_value: any, series: any) {
          return `C${((series.dataPointIndex as number) + 1)} (${valorOrdenado[series.dataPointIndex].media})`
        },
        style: { colors: ['#000'] }
      },
      colors: ObterCor(valorOrdenado),
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
          barHeight: '14px',
          dataLabels: { position: 'bottom' }
        }
      },
      legend: { show: false },
      tooltip: {
        x: { show: false },
        y: {
          title: {
            formatter: function (_value: any, series: any) {
              return valorOrdenado[series.dataPointIndex].nome + ' - '
            }
          },
          marker: { show: false }
        }
      },
      xaxis: {
        labels: { show: false },
        axisBorder: { show: false }
      },
      yaxis: {
        labels: { show: false },
        max: 1.2,
        min: -1.2,
        axisBorder: { show: false }
      }
    }

    const chart = new ApexCharts(element, options)
    await chart.render()

    // Aguarda o evento animationEnd ou timeout de segurança
    await new Promise<void>((resolve) => {
      const maxWait = setTimeout(() => resolve(), 600)
      const check = setInterval(() => {
        if (animationEnded) {
          clearTimeout(maxWait)
          clearInterval(check)
          resolve()
        }
      }, 50)
    })

    // Captura imagem final
    const dataURIResult = await chart.dataURI()
    let base64: string

    if ('imgURI' in dataURIResult) {
      base64 = dataURIResult.imgURI
    } else {
      base64 = await new Promise<string>((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result as string)
        reader.readAsDataURL(dataURIResult.blob)
      })
    }

    setGrafico(base64)
    await chart.destroy()
  }

  useEffect(() => {
    GerarGrafico()
  }, [model])

  return (
    <Flex w={'100%'} justifyContent={'center'} position={'relative'}>
      <div id={id}></div>
    </Flex>
  )
}
